/**
 *
 * EditableTable
 *
 */
import {useCallback, useState} from "react";
import * as PropTypes from "prop-types";
import {Button, Grid, Hidden, Typography} from "@material-ui/core";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import Edit from "../../images/EditIcon";
import {FormattedMessage} from "react-intl";
import GlobalMessages from "messages/messages";
import orderMessages from "../../containers/Order/messages";
import CustomInputComponent from "components/CustomInputComponent/CustomInputComponent";
import SingleSelectComponent from "components/SingleSelectComponent/SingleSelectComponent";
import DeleteIcon from "images/DeleteIcon";
import RefrezhButton from "components/RefrezhButton";
import {hasRole, ROLES} from "utils/userStorage";
import ToggleButton from "components/ToggleButton/ToggleButton";
import { useContext } from "react";
import { AbdContext } from "containers/PatientDataPage/PatientDataPage";

const useStyles = makeStyles(theme => ({
  wrapper: {
    borderRadius: "15px",
    border: "1px solid rgba(0,0,0,0.24)",
    width: "100%",
    padding: "15px",
    minWidth: "300px",
    position: "relative",
  },

  edit: { borderBottom: "1px solid rgba(0,0,0,0.24)", position: "relative" },
  borderTop: {
    borderTop: "1px solid rgba(0,0,0,0.24)",
    position: "relative",
    marginTop: theme.spacing(1),
  },
  buttonLarge: {
    display: "flex",
    paddingTop: "20px",
    justifyContent: "flex-end",
  },
  buttonMedium: {
    display: "flex",
    paddingTop: "20px",
  },

  buttonSmall: {
    position: "absolute",
    right: 0,
    zIndex: "1",
    top: 0,
  },
  components: {
    paddingRight: "10px",
    minWidth: "150px",
    fontWeight: "bold",
  },
  header: {
    paddingRight: "10px",
    minWidth: "150px",
    position: "relative",

    // "&:last-child": {
    //   display: "flex",
    //   justifyContent: "flex-end",
    //   paddingTop: "20px",
    // },
  },
  headerText: {
    fontSize: "14px",
  },

  items: {
    paddingRight: "10px",
    minWidth: "150px",
    fontWeight: "bold",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  commentWrapper: {
    height: "150px",
    border: "1px solid rgba(0,0,0,0.56)",
    borderRadius: "10px",
    width: "100%",
    "& > p": {
      overflow: "auto",
      height: "100%",
    },
    overflow: "hidden",
    padding: theme.spacing(1),
  },
  input: {
    width: "100%",
  },
  error: {
    textAlign: "center",
    display: "block",
    width: "100%",
    color: theme.palette.error.main,
  },

  buttonSave: {
    padding: "10px 10px",
    display: "flex",
    justifyContent: "center",
  },
}));

const SaveButtonLarge = withStyles(theme => ({
  root: {
    width: "200px",
    borderRadius: "50px",
    fontWeight: "bold",
  },
}))(Button);

function EditTablePatient({
  patient = { comments: "", address: {} },
  dentists,
  insurers,
  editable,
  onButtonClick,
  onPatientChange,
  insurer,
  dentist,
  selectedDentist,
  selectedInsurer,
  onDelete,
  onCreateDentist,
}) {

  //get editable from context 
  const classes = useStyles();

  const [error, setError] = useState(false);

  const handleError = useCallback(
    e => {
      if (e.target.value.length < 2) {
        setError(true);
      } else {
        setError(false);
      }
      onPatientChange({ ...patient, name: e.target.value });
    },
    [onPatientChange, patient],
  );

  let {editable2,seteditable} = useContext(AbdContext)

  return (
    <div className={classes.wrapper} style={{background:'white'}}>
      {editable2 ? (
        <Grid container>
          <Grid item xs={6} sm={4} md={4} lg={2} className={classes.header}>
            <Typography className={classes.headerText}>
              <FormattedMessage {...GlobalMessages.patientId} />
            </Typography>
            <div className={classes.items}>{patient && patient.name} </div>
          </Grid>
          <Hidden smUp>
            <div className={classes.buttonSmall}>
              <Edit onClick={onButtonClick} />
            </div>
          </Hidden>
          <Grid item xs={6} sm={4} md={4} lg={2} className={classes.header}>
            <Typography className={classes.headerText}>
              <FormattedMessage {...GlobalMessages.internal_ref} />
            </Typography>
            <div className={classes.items}>
              {patient && patient.internalRef}
            </div>
          </Grid>

          <Grid item xs={6} sm={4} md={4} lg={2} className={classes.header}>
            <Typography className={classes.headerText}>
              <FormattedMessage {...GlobalMessages.insurer} />
            </Typography>
            <div className={classes.items}>{insurer ? insurer.name : "-"}</div>
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={2} className={classes.header}>
            <Typography className={classes.headerText}>
              <FormattedMessage {...GlobalMessages.insuranceNumber} />
            </Typography>
            <div className={classes.items}>
              {patient && patient.insuranceNumber}
            </div>
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={1} className={classes.header}>
            <Typography className={classes.headerText}>
              <FormattedMessage {...GlobalMessages.dentist} />
            </Typography>
            <div className={classes.items}>{dentist ? dentist.name : "-"}</div>
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={1} className={classes.header}>
            <Typography className={classes.headerText}>
              <FormattedMessage {...orderMessages.homeTreatment} />
            </Typography>
            <div className={classes.items}>
              <FormattedMessage
                {...(patient && patient.homeShipping
                  ? GlobalMessages.yesButtonText
                  : GlobalMessages.noButtonText)}
              />
            </div>
          </Grid>

          <Hidden lgUp xsDown>
            <Grid item sm={4} md={4} lg={1} className={classes.buttonMedium}>
              <div data-cy="editButton">
                <Edit onClick={onButtonClick} />
                {onDelete &&
                  hasRole([ROLES.Admin, ROLES.CS, ROLES.KPT]) && (
                    <div data-cy="deleteButton">
                      <DeleteIcon
                        style={{ marginLeft: "10px" }}
                        onClick={onDelete}
                      />
                    </div>
                  )}
              </div>
            </Grid>
          </Hidden>
          <Hidden mdDown>
            <Grid item sm={4} md={4} lg={1} className={classes.buttonLarge}>
              <div data-cy="editButton">
                <Edit onClick={onButtonClick} />
              </div>
              {onDelete &&
                hasRole([ROLES.Admin, ROLES.CS, ROLES.KPT]) && (
                  <div data-cy="deleteButton">
                    <DeleteIcon
                      style={{ marginLeft: "10px" }}
                      onClick={onDelete}
                    />
                  </div>
                )}
            </Grid>
          </Hidden>

          {/* {hasRole([ROLES.Admin, ROLES.CS, ROLES.KPT, ROLES.Sales]) && ( */}
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.header}
            >
              <Typography className={classes.headerText}>
                <FormattedMessage {...GlobalMessages.comments} />
              </Typography>
              <div className={classes.commentItem}>
                {(patient && patient.patientComments) || "-"}
              </div>
            </Grid>
          {/* )} */}

          {patient &&
            patient.homeShipping && (
              <Grid container spacing={2} className={classes.borderTop}>
                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={4}
                  lg={2}
                  className={classes.header}
                >
                  <Typography className={classes.headerText}>
                    <FormattedMessage {...GlobalMessages.tel_nr} />
                  </Typography>
                  <div className={classes.items}>
                    {(patient &&
                      patient.address &&
                      patient.address.telephone_nr) ||
                      "-"}
                  </div>
                </Grid>

                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={4}
                  lg={2}
                  className={classes.header}
                >
                  <Typography className={classes.headerText}>
                    <FormattedMessage {...GlobalMessages.streetNoColon} />
                  </Typography>
                  <div className={classes.items}>
                    {(patient && patient.address && patient.address.street) ||
                      "-"}
                  </div>
                </Grid>

                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={4}
                  lg={2}
                  className={classes.header}
                >
                  <Typography className={classes.headerText}>
                    <FormattedMessage {...GlobalMessages.house_nr} />
                  </Typography>
                  <div className={classes.items}>
                    {(patient && patient.address && patient.address.house_nr) ||
                      "-"}
                  </div>
                </Grid>

                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={4}
                  lg={2}
                  className={classes.header}
                >
                  <Typography className={classes.headerText}>
                    <FormattedMessage {...GlobalMessages.houseNrAddendum} />
                  </Typography>
                  <div className={classes.items}>
                    {(patient &&
                      patient.address &&
                      patient.address.house_nr_addendum) ||
                      "-"}
                  </div>
                </Grid>

                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={4}
                  lg={2}
                  className={classes.header}
                >
                  <Typography className={classes.headerText}>
                    <FormattedMessage {...GlobalMessages.zipcodeNoColon} />
                  </Typography>
                  <div className={classes.items}>
                    {(patient && patient.address && patient.address.zipcode) ||
                      "-"}
                  </div>
                </Grid>

                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={4}
                  lg={2}
                  className={classes.header}
                >
                  <Typography className={classes.headerText}>
                    <FormattedMessage {...GlobalMessages.cityNoColon} />
                  </Typography>
                  <div className={classes.items}>
                    {(patient && patient.address && patient.address.city) ||
                      "-"}
                  </div>
                </Grid>

                {patient.address &&
                  patient.address.comments && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className={classes.header}
                    >
                      <Typography className={classes.headerText}>
                        <FormattedMessage {...GlobalMessages.comments} />
                      </Typography>
                      <div className={classes.commentItem}>
                        {(patient &&
                          patient.address &&
                          patient.address.comments) ||
                          "-"}
                      </div>
                    </Grid>
                  )}
              </Grid>
            )}
        </Grid>
      ) : (
        <form onSubmit={onButtonClick}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} className={classes.header}>
              <div className={classes.components} data-cy="nameComponent">
                <CustomInputComponent
                  isError={error}
                  label={<FormattedMessage {...GlobalMessages.patientId} />}
                  className={classes.input}
                  value={patient.name}
                  onChange={e => {
                    handleError(e);
                  }}
                  helperText="Minimal 2 Characters"
                  isRequired
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.header}>
              <div
                className={classes.components}
                data-cy="internalRefComponent"
              >
                <CustomInputComponent
                  className={classes.input}
                  label={<FormattedMessage {...GlobalMessages.internal_ref} />}
                  value={patient.internalRef}
                  onChange={e =>
                    onPatientChange({ ...patient, internalRef: e.target.value })
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className={classes.header}>
              <div className={classes.components} data-cy="insurerComponent">
                <SingleSelectComponent
                  value={selectedInsurer}
                  label={<FormattedMessage {...GlobalMessages.insurer} />}
                  noIcon
                  options={insurers}
                  onChange={dropDownSelected => {
                    onPatientChange({
                      ...patient,
                      careId: dropDownSelected && dropDownSelected.value,
                    });
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className={classes.header}>
              <div
                className={classes.components}
                data-cy="insuranceNumberComponent"
              >
                <CustomInputComponent
                  className={classes.input}
                  label={
                    <FormattedMessage {...GlobalMessages.insuranceNumber} />
                  }
                  value={patient.insuranceNumber}
                  onChange={e =>
                    onPatientChange({
                      ...patient,
                      insuranceNumber: e.target.value,
                    })
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className={classes.header}>
              <div className={classes.components} data-cy="dentistComponent">
                <SingleSelectComponent
                  value={selectedDentist}
                  noIcon
                  label={<FormattedMessage {...GlobalMessages.dentist} />}
                  canCreate
                  additionalAutocompleteOptions={{
                    clearOnBlur: false,
                    selectOnFocus: true,
                  }}
                  onChange={({ value, isNew = false }) => {
                    // Create new dentist
                    if (isNew) {
                      onCreateDentist({ name: value }, dentist => {
                        onPatientChange({
                          ...patient,
                          dentistId: dentist.id,
                        });
                      });
                    } else {
                      onPatientChange({ ...patient, dentistId: value });
                    }
                  }}
                  options={dentists}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={6} className={classes.header}>
              <div className={classes.components}>
                <ToggleButton
                  label={<FormattedMessage {...orderMessages.homeTreatment} />}
                  onChange={({ value }) => {
                    onPatientChange({ ...patient, homeShipping: value });
                  }}
                  options={[
                    {
                      id: 1,
                      label: (
                        <FormattedMessage {...GlobalMessages.yesButtonText} />
                      ),
                      value: true,
                    },
                    {
                      id: 2,
                      label: (
                        <FormattedMessage {...GlobalMessages.noButtonText} />
                      ),
                      value: false,
                    },
                  ]}
                  value={patient && patient.homeShipping}
                />
              </div>
            </Grid>
            {/* {hasRole([ROLES.Admin, ROLES.CS, ROLES.KPT, ROLES.Sales]) && ( */}
              <Grid item xs={12} sm={12} md={12} className={classes.header}>
                <div className={classes.components}>
                  <CustomInputComponent
                    multiline
                    label={<FormattedMessage {...GlobalMessages.comments} />}
                    className={classes.input}
                    value={patient && patient.patientComments}
                    onChange={e => {
                      onPatientChange({
                        ...patient,
                        comments: e.target.value,
                        patientComments: e.target.value,
                      });
                    }}
                  />
                </div>
              </Grid>
            {/* )} */}

            {patient &&
              patient.homeShipping && (
                <>
                  <Grid item xs={12} className={classes.header}>
                    <div className={classes.components}>
                      <CustomInputComponent
                        label={<FormattedMessage {...GlobalMessages.tel_nr} />}
                        className={classes.input}
                        value={
                          (patient.address && patient.address.telephone_nr) ||
                          ""
                        }
                        onChange={e =>
                          onPatientChange({
                            ...patient,
                            address: {
                              ...patient.address,
                              telephone_nr: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className={classes.header}>
                    <div className={classes.components}>
                      <CustomInputComponent
                        label={
                          <FormattedMessage {...GlobalMessages.streetNoColon} />
                        }
                        className={classes.input}
                        value={
                          (patient.address && patient.address.street) || ""
                        }
                        onChange={e =>
                          onPatientChange({
                            ...patient,
                            address: {
                              ...patient.address,
                              street: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} className={classes.header}>
                    <div className={classes.components}>
                      <CustomInputComponent
                        className={classes.input}
                        label={
                          <FormattedMessage {...GlobalMessages.house_nr} />
                        }
                        value={
                          (patient.address && patient.address.house_nr) || ""
                        }
                        onChange={e =>
                          onPatientChange({
                            ...patient,
                            address: {
                              ...patient.address,
                              house_nr: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} className={classes.header}>
                    <div className={classes.components}>
                      <CustomInputComponent
                        label={
                          <FormattedMessage
                            {...GlobalMessages.houseNrAddendum}
                          />
                        }
                        className={classes.input}
                        value={
                          (patient.address &&
                            patient.address.house_nr_addendum) ||
                          ""
                        }
                        onChange={e =>
                          onPatientChange({
                            ...patient,
                            address: {
                              ...patient.address,
                              house_nr_addendum: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} className={classes.header}>
                    <div className={classes.components}>
                      <CustomInputComponent
                        label={
                          <FormattedMessage
                            {...GlobalMessages.zipcodeNoColon}
                          />
                        }
                        className={classes.input}
                        value={
                          (patient.address && patient.address.zipcode) || ""
                        }
                        onChange={e =>
                          onPatientChange({
                            ...patient,
                            address: {
                              ...patient.address,
                              zipcode: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} className={classes.header}>
                    <div className={classes.components}>
                      <CustomInputComponent
                        label={
                          <FormattedMessage {...GlobalMessages.cityNoColon} />
                        }
                        className={classes.input}
                        value={(patient.address && patient.address.city) || ""}
                        onChange={e =>
                          onPatientChange({
                            ...patient,
                            address: {
                              ...patient.address,
                              city: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} className={classes.header}>
                    <div className={classes.components}>
                      <CustomInputComponent
                        multiline
                        label={
                          <FormattedMessage {...GlobalMessages.comments} />
                        }
                        className={classes.input}
                        value={
                          (patient.address && patient.address.comments) || ""
                        }
                        onChange={e =>
                          onPatientChange({
                            ...patient,
                            address: {
                              ...patient.address,
                              comments: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                  </Grid>
                </>
              )}

            <Grid item container className={classes.buttonSave}>
              <div data-cy="saveButton">
                <RefrezhButton disabled={error} onClick={onButtonClick}>
                  <FormattedMessage {...GlobalMessages.save} />
                </RefrezhButton>
              </div>
            </Grid>
          </Grid>
        </form>
      )}
    </div>
  );
}

EditTablePatient.propTypes = {
  patient: PropTypes.object,
  dentists: PropTypes.array,
  insurers: PropTypes.array,
  editable: PropTypes.bool,
  onButtonClick: PropTypes.func,
  onPatientChange: PropTypes.func,
  insurer: PropTypes.object,
  dentist: PropTypes.object,
  selectedDentist: PropTypes.object,
  selectedInsurer: PropTypes.object,
};

export default EditTablePatient;
